export default {
  'footer': {
    'start': '시작하기',
    'confirm': '@:terms.confirm',
    'register': '@:terms.register하기',
    'register-completed': '@:terms.register 완료',
    'payment': '@:terms.payment하기',
    'delete': '@:terms.delete하기',
  },
  'header': {
    'main': '세금 @:terms.payment',
    'certificates': '@:terms.certificate 관리',
    'banks': '@:terms.bank-account 정보',
    'select-bank-code': '@:terms.withdrawal @:terms.bank',
    'select-bank': '@:terms.bank-account',
    'user': '@:terms.user',
    'edit': '@:terms.edit',
    'certificate': {
      'status': {
        'success': '등록됨',
        'pending': '등록 안함',
      },
    },
  },
  'menu': {
    'tax': '@:terms.tax',
    'invoice': '@:terms.purchase-invoice',
    'home': '@:terms.home',
    'setting': '@:terms.setting',
  },
  'error': {
    'cert': {
      'expired': '@:terms.certificate가 만료되었습니다.',
      'expires-soon': '@:terms.certificate가 오늘 만료됩니다.  | @:terms.certificate가 내일 만료됩니다. | ' +
        '@:terms.certificate가 {days}@:terms.days @:terms.after 만료됩니다.',
    },
  },
}
